var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { RewardCardContainer, MessageNoData, GenericErrorRefresh, ButtonShowAllOffers, ContainerImageText, LoadingSkeletonVertical, } from '../../../shared/rewards-hub';
import { InfoOffersContext, ChallengesContext } from '../../../../contexts';
import { rhGeneral } from '../../../../constants/RewardsHub';
import { useIsMobile } from '../../../../hooks';
import { ChallengeTile, LoadingTile, OfferTile } from './OfferTiles';
import { fallbackImage } from '../../../../images';
var assets = rhGeneral.assets;
var cardProps = {
    title: 'Offers Available ',
    faqTitle: 'Offers ',
    headerUrl: rhGeneral.faqAnchor,
    dataTestID: 'offersCard',
};
var useGetIsMobile = function () { return useIsMobile().isMobile; };
export var LoadingStateOffers = function () {
    var isMobile = useGetIsMobile();
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, cardProps),
        React.createElement(LoadingSkeletonVertical, { isMobile: isMobile })));
};
export var ErrorStateBoth = function () {
    var isMobile = useGetIsMobile();
    var getChallengesInfo = React.useContext(ChallengesContext).getChallengesInfo;
    var refreshOffers = React.useContext(InfoOffersContext).refreshOffers;
    var refreshFunc = React.useCallback(function () {
        getChallengesInfo === null || getChallengesInfo === void 0 ? void 0 : getChallengesInfo({ force: true });
        refreshOffers === null || refreshOffers === void 0 ? void 0 : refreshOffers();
    }, [getChallengesInfo, refreshOffers]);
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: true });
    var alertPaddingWorkaround = { marginBottom: '-16px' };
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        React.createElement("div", { className: "sui-flex sui-flex-col sui-mb-[-16px]", style: alertPaddingWorkaround },
            React.createElement(GenericErrorRefresh, { refreshFunc: refreshFunc }))));
};
export var NoDataStateOffers = function () {
    var isMobile = useGetIsMobile();
    var OffersImage = function () { return (React.createElement("div", { className: "sm:sui-mt-10" },
        React.createElement("img", { src: assets.PersonalOffers, alt: "Offers", width: isMobile ? '45px' : '86px', height: isMobile ? '45px' : '86px', onError: fallbackImage }))); };
    return isMobile ? (React.createElement(ContainerImageText, { ImageComponent: OffersImage, dimensionsMW: "" },
        React.createElement(MessageNoData, { card: "Offers" }))) : (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6" },
        React.createElement(MessageNoData, { card: "Offers" }),
        React.createElement(OffersImage, null)));
};
var useRenderChallenges = function () {
    var _a = React.useContext(ChallengesContext), getChallengesInfo = _a.getChallengesInfo, isChallengeLoading = _a.isChallengeLoading, hasChallengeError = _a.hasChallengeError, challengesInfo = _a.challengesInfo, hideChallenge = _a.hideChallenge;
    var refreshChallenges = React.useCallback(function () {
        getChallengesInfo === null || getChallengesInfo === void 0 ? void 0 : getChallengesInfo({ force: true });
    }, [getChallengesInfo]);
    // Show loading tile while loading
    if (isChallengeLoading)
        return [React.createElement(LoadingTile, { key: "loadingTile-1" })];
    // Show error tile when there's an error and not loading
    if (hasChallengeError && !isChallengeLoading) {
        return [
            React.createElement(GenericErrorRefresh, { key: "errorTile-1", refreshFunc: refreshChallenges }),
        ];
    }
    var allChallenges = (challengesInfo === null || challengesInfo === void 0 ? void 0 : challengesInfo.challenges) || [];
    var activeChallenges = allChallenges.filter(function (challenge) { return !hideChallenge(challenge); });
    return activeChallenges.length
        ? activeChallenges.map(function (challenge, idx) { return (React.createElement(ChallengeTile, { key: "challengeTile-".concat(idx), challenge: challenge, isFirstTile: idx === 0 })); })
        : [];
};
var useRenderOffers = function (listCL) {
    var _a = React.useContext(InfoOffersContext), hasError = _a.hasError, refreshOffers = _a.refreshOffers, offerList = _a.offerList, isLoading = _a.isLoading;
    if (isLoading)
        return [React.createElement(LoadingTile, { key: "loadingTile-2" })];
    if (!isLoading && hasError) {
        console.log('here at renderOffers error');
        return [
            React.createElement(GenericErrorRefresh, { key: "errorTile-2", refreshFunc: refreshOffers }),
        ];
    }
    return ((offerList === null || offerList === void 0 ? void 0 : offerList.map(function (offer, idx) { return (React.createElement(OfferTile, { key: "offerTile-".concat(idx), perk: offer, isFirstTile: !(listCL === null || listCL === void 0 ? void 0 : listCL.length) && idx === 0 })); })) || []);
};
export var HasDataStateOffers = function () {
    var isMobile = useGetIsMobile();
    var _a = React.useContext(ChallengesContext), isChallengeLoading = _a.isChallengeLoading, hasChallengeError = _a.hasChallengeError;
    var _b = React.useContext(InfoOffersContext), isLoadingOffers = _b.isLoading, hasOffersError = _b.hasError;
    // Move hooks before any conditional logic
    var TILE_LIMIT = isMobile ? 2 : 3;
    var listCL = useRenderChallenges();
    var listOL = useRenderOffers(listCL);
    // Check if both services have errors
    var bothHaveErrors = hasChallengeError && hasOffersError;
    // If both have errors, show the combined error state
    if (bothHaveErrors && !isChallengeLoading && !isLoadingOffers) {
        return React.createElement(ErrorStateBoth, null);
    }
    var isReadyAndErrorFree = !isLoadingOffers &&
        !isChallengeLoading &&
        !hasChallengeError &&
        !hasOffersError;
    var fullTileList = __spreadArray(__spreadArray([], listCL, true), listOL, true);
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: !isChallengeLoading && !isLoadingOffers, itemAmount: isReadyAndErrorFree ? fullTileList === null || fullTileList === void 0 ? void 0 : fullTileList.length : undefined, FooterButton: (fullTileList === null || fullTileList === void 0 ? void 0 : fullTileList.length) > TILE_LIMIT ? ButtonShowAllOffers : undefined });
    var isListEmpty = fullTileList.length <= 0 && isReadyAndErrorFree;
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        React.createElement("div", { className: "sui-pt-4" }),
        isListEmpty ? React.createElement(NoDataStateOffers, null) : fullTileList.slice(0, TILE_LIMIT)));
};
